module.exports = __webpack_public_path__ + "static/media/explore-papers.6faa356d.svg";